import {Hydra} from '../generic/hydra';

import {MandatType as MandatTypeBaseInterface} from '../../interface/api/MandatType';

export type MandatTypeInterface = MandatTypeBaseInterface;

export class MandatType extends Hydra implements MandatTypeInterface {

    id?: number | null;

    label?: string | null;

    code?: string | null;

    rolesInduits?: any[] | null = [];


    constructor(options: MandatTypeInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
